import React from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

function SectionHero() {
  return (
    <Box tag="section">
      <Box
        minHeight={{
          xs: '45vh',
          md: '60vh',
        }}
        backgroundSize="cover"
        backgroundPosition="center"
        backgroundImage={{
          xs: 'people-working-together/people-working-together@xs-2x.jpg',
          md: 'people-working-together/people-working-together@md-1x.jpg',
          lg: 'people-working-together/people-working-together@lg-1x.jpg',
        }}
      />
      <Box
        paddingHorizontal={{ xs: '6x', md: '12x', lg: 56 }}
        paddingVertical="12x"
      >
        <Typography
          variant="subtitle"
          textAlign="center"
          marginBottom="4x"
          intlKey="COMMON.ABOUT_PAGE.SECTION_HERO.TITLE"
        />
        <Typography
          variant="supertitle"
          textAlign="center"
          intlKey="COMMON.ABOUT_PAGE.SECTION_HERO.PAGE_HEADING"
          intlValues={{ br: <br /> }}
        />
      </Box>
    </Box>
  );
}

export default SectionHero;
